export class storeRegistrationController {
    loadComplete: boolean;

    constructor(private $ocLazyLoad: any, private $state) {
        "ngInject"
    }
    $onInit() {
        this.$ocLazyLoad.load("registration").then(res => {
            this.loadComplete = true
            this.$state.go('Order')
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/store-registration/store-registration.controller.ts